import * as HTTP from '../http'
import swal from 'sweetalert2'

const defaultPage = 1
const defaultPerPage = 20

function _checkQueryString (url) {
  return url
}

function _processUrl (domain, route, id, columns, relations, page, perPage) {
  let url = domain
  let hasUrlParams = false

  if (id !== undefined && id !== null) {
    url = _checkQueryString(url)
    url += '/' + id
  }
  url += (route ? '/' + route : '')
  url += '?q='

  if (page !== undefined && page !== null && page !== false) {
    page = page || defaultPage
    perPage = perPage || defaultPerPage
    url = _checkQueryString(url)
    url += '&_page=' + page + '&_limit=' + perPage
    hasUrlParams = true
  }

  if (columns !== null && columns !== undefined && columns.length > 0) {
    url = _checkQueryString(url)
    columns.forEach(function (val) {
      if (val.length > 0) {
        url += '&_columns[]=' + val
      }
    })
    hasUrlParams = true
  }

  if (relations !== null && relations !== undefined && relations.length > 0) {
    url = _checkQueryString(url)
    relations.forEach(function (val) {
      if (val.length > 0) {
        url += '&_with[]=' + val
      }
    })
    hasUrlParams = true
  }
  if (!hasUrlParams) {
    url = url.replace('?q=', '')
  }
  return url
}

function _all (domain, route, id, columns, relations, page, perPage) {
  return HTTP.get(_processUrl(domain, route, id, columns, relations, page, perPage))
}

function _get (domain, route, id, columns, relations, page, perPage) {
  return HTTP.get(_processUrl(domain, route, id, columns, relations, page, perPage))
}

function _search (domain, route, data, columns, relations, page, perPage, customSearch) {
  if (data === undefined || data === null) {
    data = null
  }
  page = page || defaultPage
  perPage = perPage || defaultPerPage
  customSearch = customSearch || false
  return HTTP.post(_processUrl((customSearch ? '' : 'search/') + domain, route, null, columns, relations, page, perPage), data)
}

function _post (domain, route, id, data) {
  return HTTP.post(_processUrl(domain, route, id), data)
}

function _put (domain, route, id, data) {
  return HTTP.put(_processUrl(domain, route, (id || data.id)), data)
}

function _save (domain, route, id, data) {
  if (data.id !== undefined && data.id !== null && data.id !== '' && data.id > 0) {
    return _put(domain, route, id, data)
  }
  return _post(domain, route, id, data)
}

function _destroy (domain, route, id) {
  return new Promise((resolve, reject) => {
    swal({
      title: 'Deseja realmente remover esse item?',
      text: 'Essa ação não pode ser revertida!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, continuar!'
    })
      .then(() => {
        HTTP.destroy(_processUrl(domain, route, id))
          .then(() => {
            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })
      .catch(e => {
        reject(e)
      })
  })
}

export const all = _all
export const get = _get
export const search = _search
export const post = _post
export const put = _put
export const save = _save
export const destroy = _destroy



// WEBPACK FOOTER //
// ./src/app/services/restfulService.js